import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import TeamListCard from '../TeamListCard/TeamListCard.vue'
import SortDropdown from '../SortDropdown/SortDropdown.vue'

export default {
    name: 'TeamList',
    components: {
        TeamListCard,
        SortDropdown
    },
    props: {
        source: {
            type: String,
            required: true
        },
        stafetId: {
            type: String,
            required: true
        },
        guid: {
            type: String,
            required: true
        },
        take: {
            type: Number,
            default: 18
        },
        hideNoResults: {
            type: Boolean,
            required: false,
            default: false
        },
        filterShown: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup(props) {
        const store = useStore()
        const teamsShownAmount = ref(props.take)

        onMounted(() => {

            const urlTemplate = props.source === 'profil'
                ? process.env.GET_PROFILE_TEAMS_LIST
                : process.env.GET_STAFET_TEAM_LIST
            const url = urlTemplate
                .replace('[stafetId]', props.stafetId)
                .replace('[pageId]', store.state.main.page_id)

            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: url
            })

            store.dispatch('search/performZeroSearch', {
                guid: props.guid
            })

            store.dispatch('search/performSearch', {
                guid: props.guid,
                skip: 0,
                take: props.take
            })
        })

        const getLabel = (key, strings) => {
            let label = store.getters['labels/getLabel']({
                labelCollection: 'teamList',
                labelKey: key
            })

            if (strings) {
                strings.map((string, index) => {
                    label = label.replace(`{${index}}`, string)
                })
            }
            return label
        }

        const sortOptions = {
            name: 'Sorter',
            options: [
                {
                    name: getLabel('sortListAlphabetical'),
                    handler: 'alphabetical'
                },
                {
                    name: getLabel('sortListIndsamlet'),
                    handler: 'highestCollected'
                },
                {
                    name: getLabel('sortListSenestOprettet'),
                    handler: 'latest'
                },
            ]
        }

        const sortingHandler = function (sorting) {
            store.dispatch('search/performSearch', {
                guid: props.guid,
                sorting
            })
        }

        const teams = computed(() => {
            const teams = store.state.search.results[props.guid] ?? []
            teamsShownAmount.value = teams.length
            return teams
        })

        const totalAmount = computed(() => {
            return store.state.search.scoped_total[props.guid] ?? 0
        })

        const showSpinner = computed(
            () => store.state.search.search_inprogress[props.guid]
        )

        const getMoreResults = function () {
            store.dispatch('search/performMoreSearch', {
                guid: props.guid
            })
        }

        return {
            sortOptions,
            sortingHandler,
            getLabel,
            teams,
            teamsShownAmount,
            totalAmount,
            getMoreResults,
            showSpinner
        }
    }
}
